export default {
      id: "male-usage",
      viewBox: "0 0 10 16",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#male",
      toString: function () {
        return this.url;
      }
    }